module.exports = __webpack_public_path__ + "images/frontpage_design@1x.png?20b9aadb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_design@1x.png
// module id = 630
// module chunks = 7